/**
 *
 * MainModeCourse
 *
 */

import Swal from 'sweetalert2';
//import { findIndex } from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
//import Chart from 'chart.js';
import $ from 'jquery';

import WayFindBar from '@/components/WayFindBar.vue';
// import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
//import Player from '@/components/Player.vue';
import Spinner from '@/components/Spinner.vue';
import { LOADING_MESSAGE } from './MainModeCourse.constants';

import {
  MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE_CHUNK_NAME,
  MAIN_MODE_COURSE_VIDEO_MODE_PAGE_CHUNK_NAME,
  MAIN_MODE_COURSE_LIVE_MODE_PAGE_CHUNK_NAME,
  //MAIN_MODE_COURSE_EXERCISE_PAGE_CHUNK_NAME,
} from '@/constants/index';
//import {
//  MAIN_MODE_BOOK_PAGE,
//  FAVORITE_PAGE /* , IDENTITY_PAGE */,
//} from '../../../constants/routes';

export default {
  name: 'MainModeCourse',

  components: {
    WayFindBar,
    // ToolBar,
    Footer,
    //Player,
    Aside,
    Spinner,
  },

  data: () => {
    return {
      //redirectToFavorite: FAVORITE_PAGE,
      //redirectTo: MAIN_MODE_BOOK_PAGE,
      loadingMessage: LOADING_MESSAGE,
      //currentVideo: {},
      //isShowPlayer: false,
      //hideCurrentBtn: false,
      //
      paramsGetCourse: null,
      //isGettingCourse: false,

      isScrollOpen: false,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
      ms_pztest: 'pztest',
    }),

    ...mapState('MainModeCourse', {
      ms_isRequest: 'isRequest',
      //ms_isRankingLoading: 'isRankingLoading',
      //ms_rankingList: 'rankingList',
      //ms_isDiagnosisLoading: 'isDiagnosisLoading',
      //ms_isTaskStatusLoading: 'isTaskStatusLoading',
    }),

    ...mapGetters({
      //FilterData: 'MainModeCourse/FilterData',
      //Files: 'MainModeCourse/Files',
      Course: 'MainModeCourse/Course',
      //Collection: 'MainModeCourse/Collection',
      //Books: 'MainModeCourse/Books',
      //UnissuedBooks: 'MainModeCourse/UnissuedBooks',
      //EarlyBooks: 'MainModeCourse/EarlyBooks',
      //userInfo: 'userInfo',
      //ReadyToPlayVideos: 'MainModeCourse/ReadyToPlayVideos',
      //immLoading: 'immLoading',
      //hasCurrentBook: 'MainModeCourse/hasCurrentBook',
    }),

    ...mapGetters('MainModeCourse', {
      //mg_rankingInfo: 'rankingInfo',
      mg_diagnosisInfo: 'diagnosisInfo',
      //mg_taskStatusInfo: 'taskStatusInfo',
      //mg_myTaskStatus: 'myTaskStatus',
    }),

    //c_isChallengeMode: function () {
    //  return MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE_CHUNK_NAME === this.$route.name;
    //},

    courseId: function () {
      return this.$route.params.courseId;
    },

    c_isCourseMode() {
      return (
        MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE_CHUNK_NAME === this.$route.name ||
        MAIN_MODE_COURSE_VIDEO_MODE_PAGE_CHUNK_NAME === this.$route.name ||
        MAIN_MODE_COURSE_LIVE_MODE_PAGE_CHUNK_NAME === this.$route.name
      );
    },

    challengeModePage: function () {
      return `/course/${this.$route.params.courseId}/challenge-mode`;
    },

    //videoModeCoursePage: function () {
    //  return `/course/${this.$route.params.courseId}/video-mode`;
    //},

    //liveModeCoursePage: function () {
    //  return `/course/${this.$route.params.courseId}/live-mode`;
    //},

    exercisePage: function () {
      return `/course/${this.$route.params.courseId}/exercise`;
    },

    eventsPage: function () {
      return `/course/${this.$route.params.courseId}/events`;
    },

    flashCardPage: function () {
      return `/course/${this.$route.params.courseId}/flash-card-landing`;
    },

    favoritePage: function () {
      return `/course/${this.$route.params.courseId}/favorite`;
    },

    rankingPage: function () {
      return `/course/${this.$route.params.courseId}/ranking`;
    },

    materialPage: function () {
      return `/course/${this.$route.params.courseId}/material`;
    },

    classroomPage: function () {
      return `/course/${this.$route.params.courseId}/classroom`;
    },

    //c_isCpntRequest() {
    //  return this.isGettingCourse || this.ms_isRequest;
    //},

    //c_isNoAuth() {
    //  return Boolean(this.userInfo.authenticated === -1) && Boolean(this.userInfo.hasPay);
    //},

    //SortedBooks: function () {
    //  return this.Books
    //    ? [...this.Books].sort((v1, v2) => v2.bookLevel - v1.bookLevel).filter((v) => !v.otherBook)
    //    : [];
    //},
    //SortedUnissuedBooks: function () {
    //  return this.UnissuedBooks ? this.UnissuedBooks.filter((v) => !v.otherBook) : [];
    //},

    //c_isShowTaskStatusInfo() {
    //  return (
    //    this.mg_taskStatusInfo &&
    //    (this.mg_taskStatusInfo.totalItem > 0 || this.mg_taskStatusInfo.personalTaskTotalCount > 0)
    //  );
    //},
  },

  methods: {
    ...mapActions({
      //addToFavoriteList: 'MainModeCourse/addToFavoriteList',
      getCourse: 'MainModeCourse/getCourse',
      //getCourseWithoutSetRequestStatus: 'MainModeCourse/getCourseWithoutSetRequestStatus',
    }),

    ...mapActions('MainModeCourse', {
      //ma_getRankingList: 'getRankingList',
      ma_getDiagnosisInfo: 'getDiagnosisInfo',
      //ma_getCourseTaskStatus: 'getCourseTaskStatus',
      //ma_getCourseMultiTaskStatus: 'getCourseMultiTaskStatus',
      //ma_getCourseMyTaskStatus: 'getCourseMyTaskStatus',
    }),

    //noAccessInfo() {
    //  Swal.fire({
    //    width: '400px',
    //    backdrop: false,
    //    icon: 'warning',
    //    title: `没有权限`,
    //    text: '亲爱的学员您还没有购买该课程, 购买课程后再来吧～',
    //    showConfirmButton: false,
    //    timer: 1500,
    //  });
    //},

    setIsScrollOpen() {
      this.isScrollOpen = this.$refs.main.scrollTop > 150;
    },

    //setHideCurrentBtn() {
    //  const context = this;
    //  setTimeout(() => {
    //    context.hideCurrentBtn = true;
    //  }, 15000);
    //},

    //changeBook(event) {
    //  let value = event.target.value;
    //  this.$store.commit('MainModeCourse/FILTER_MAIN_COLLECTION_BOOK', value);
    //},

    //openPlayer(bullet) {
    //  this.currentVideo = this.ReadyToPlayVideos.find((v) => v.bulletId == bullet.bulletId);
    //  this.isShowPlayer = true;
    //},

    //closePlayer() {
    //  this.isShowPlayer = false;
    //  this.$store.commit('MainModeCourse/REMOVE_UNFOLLOW_VIDEOS');
    //},

    //goToNextVideo() {
    //  const index = findIndex(this.ReadyToPlayVideos, this.currentVideo);
    //  this.currentVideo = this.ReadyToPlayVideos[index + 1];
    //},

    //noFiles() {
    //  Swal.fire({
    //    width: '400px',
    //    icon: 'info',
    //    title: `没有课程相关资料`,
    //    showConfirmButton: false,
    //    timer: 1200,
    //  });
    //},

    //noCollection() {
    //  Swal.fire({
    //    // position: 'top-end',
    //    width: '400px',
    //    icon: 'info',
    //    title: `您还没有收藏本课视频`,
    //    showConfirmButton: false,
    //    timer: 1200,
    //  });
    //},

    //getRankingList() {
    //  this.ma_getRankingList(this.$route.params.courseId);
    //},

    getDiagnosisInfo() {
      this.ma_getDiagnosisInfo(this.$route.params.courseId);
    },

    //getCourseTaskStatus() {
    //  this.ma_getCourseMyTaskStatus({ courseId: this.courseId });
    //},

    //gotoTrainingCamps() {
    //  this.$router.push(`/training-camps/${this.courseId}`);
    //},

    _mainModeCourseCreated() {
      if (this.$route.params.courseId !== '' + this.Course.courseId) {
        //this.isGettingCourse = true;
        this.paramsGetCourse = this.getCourse(this.courseId);
        window.promiseGetCourse = this.paramsGetCourse;
        this.getDiagnosisInfo();
      }
    },

    async _mainModeCourseMounted() {
      window.addEventListener('scroll', this.setIsScrollOpen, true);
      await this.paramsGetCourse;
      //this.isGettingCourse = false;
      //if (
      //  !this.Course.freeMode &&
      //  this.c_isNoAuth &&
      //  MAIN_MODE_COURSE_EXERCISE_PAGE_CHUNK_NAME !== this.$route.name
      //) {
      //  Swal.fire({
      //    icon: 'info',
      //    title: '您还没有认证',
      //    text: '亲爱的学员请先完成认证',
      //    confirmButtonColor: '#3085d6',
      //    confirmButtonText: '去认证',
      //    allowOutsideClick: false,
      //  }).then((result) => {
      //    if (result.value) {
      //      this.$router.push(IDENTITY_PAGE);
      //    }
      //  });
      //  return;
      //}
      if (this.Course.needDeferOperation) {
        Swal.fire({
          allowOutsideClick: false,
          width: '400px',
          backdrop: true,
          icon: 'warning',
          title: `请先设置您的延考日期`,
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: '确定',
        }).then((result) => {
          if (result.value) {
            this.$router.go(-1);
          }
        });
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
      //const ctx = document.getElementById('pzChart');
      //if (ctx) {
      //  new Chart(ctx, {
      //    type: 'doughnut',
      //    data: {
      //      datasets: [
      //        {
      //          data: [
      //            this.Course.courseAnalysis.countLevel0,
      //            this.Course.courseAnalysis.countLevel1,
      //            this.Course.courseAnalysis.countLevel2,
      //            this.Course.courseAnalysis.countLevel3,
      //            this.Course.courseAnalysis.countLevel4,
      //          ],
      //          backgroundColor: ['#EBEDF0', '#E5B3FF', '#D480FF', '#AA00FF', '#7C00BA'],
      //        },
      //      ],
      //      labels: ['未开始', '练习中', '初步了解', '熟悉', '精通'],
      //    },
      //    options: {
      //      responsive: true,
      //      legend: {
      //        display: false,
      //        position: 'top',
      //      },
      //      tooltips: {
      //        enabled: false,
      //      },
      //      cutoutPercentage: 80,
      //
      //      animation: {
      //        animateScale: true,
      //        animateRotate: true,
      //      },
      //    },
      //  });
      //}
    },

    _mainModeCourseBeforeDestroy() {
      window.removeEventListener('scroll', this.setIsScrollOpen, true);
    },
  },

  created() {
    //this.getCourseData();
    this._mainModeCourseCreated();
  },

  mounted() {
    //const context = this;
    window.scrollTo(0, 0);
    this._mainModeCourseMounted();
    /* setTimeout(() => {
      context.hideCurrentBtn = true;
    }, 15000); */
  },

  beforeDestroy() {
    this._mainModeCourseBeforeDestroy();
  },

  beforeRouteLeave(to, from, next) {
    delete window.promiseGetCourse;
    next();
  },
};
